/*
 * @创建文件时间: 2019-11-08 10:37:14
 * @最后修改人: lfq
 * @最后修改时间: 2020-05-26 17:19:13
 * @联系Qq:1360484677
 * @文件介绍: 
 */
import cookies from './util.cookies'
import db from './util.db'
import log from './util.log'
import session from './util.session'

const util = {
    cookies,
    db,
    log,
    session
}

util.isLoseLogin = function() {
    // const isLoseStartTime = "2024/04/15 00:00:00";//
    // const isLoseEndTime = "2024/04/30 23:59:59";//过期时间

    const isLoseBool = true; //是否开启限制并提示

    let valueForm = {
        isLoseBool: isLoseBool, //总开关
        // isLoseStartTime: isLoseStartTime,
        // isLoseTime: isLoseEndTime,
        message: "当前系统license将于12月31日过期，请及时更新！",
        // isLose: (( new Date().getTime() - new Date(isLoseEndTime).getTime() ) > 0 ),//是否过期
        // isMessage: (( new Date().getTime() - new Date(isLoseStartTime).getTime() ) > 0 ),//是否开始提示
    }
    return valueForm
}

/**
 * @description 更新标题
 * @param {String} title 标题
 */
util.title = function(titleText) {
        const processTitle = process.env.VUE_APP_TITLE || 'D2Admin'
        window.document.title = `${processTitle}${titleText ? ` | ${titleText}` : ''}`
}

/**
 * @description 打开新页面
 * @param {String} url 地址
 */
util.open = function (url) {
  var a = document.createElement('a')
  a.setAttribute('href', url)
  a.setAttribute('target', '_blank')
  a.setAttribute('id', 'd2admin-link-temp')
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(document.getElementById('d2admin-link-temp'))
}

util.statusOptions={
  auditStatus:[
      {label:'未提交',value:'1',color:'info'},
      {label:'已提交',value:'2',color:'warning'},
      {label:'已审核',value:'3',color:'primary'},
      {label:'已驳回',value:'4',color:'danger'},
      {label:'处理中',value:'5',color:'warning'},
      {label:'已处理',value:'6',color:'success'},
      {label:'已完成',value:'8',color:'success'},
      {label:'已完成',value:'9',color:'success'},
      {label:'无',value:'0',color:''}
  ],
  auditStatusMinor:[
      {label:'未提交',value:'1',color:'info'},
      {label:'已提交',value:'2',color:'warning'},
      {label:'已下发',value:'3',color:'primary'},
      {label:'已驳回',value:'4',color:'danger'},
      {label:'处理中',value:'5',color:'warning'},
      {label:'已处理',value:'6',color:'success'},
      {label:'已完成',value:'8',color:'success'},
      {label:'已完成',value:'9',color:'success'},
      {label:'无',value:'0',color:''}
  ],
  auditStatusApply:[
      {label:'未提交',value:'1',color:'info'},
      {label:'待审核',value:'2',color:'warning'},
      {label:'已审核',value:'3',color:'primary'},
      {label:'已驳回',value:'4',color:'danger'},
      {label:'处理中',value:'5',color:'warning'},
      {label:'已处理',value:'6',color:'success'},
      {label:'已完成',value:'8',color:'success'},
      {label:'已完成',value:'9',color:'success'},
      {label:'无',value:'0',color:''}
  ],
  auditStatusOrder:[
      {label:'未下发',value:'1',color:'info'},
      {label:'已下发',value:'2',color:'warning'},
      {label:'已提交',value:'3',color:'primary'},
      {label:'已驳回',value:'4',color:'danger'},
      {label:'处理中',value:'5',color:'warning'},
      {label:'已处理',value:'6',color:'success'},
      {label:'已完成',value:'8',color:'success'},
      {label:'已完成',value:'9',color:'success'},
      {label:'无',value:'0',color:''}
  ],
  targetType:[
      {label:'构件各检测指标扣分值',value:'1',color:'warning'},
      {label:'执行标准检查指标',value:'2',color:'warning'},
      {label:'t值',value:'3',color:'warning'},
      {label:'部件类别及权重对照表',value:'4',color:'warning'},
      {label:'桥梁结构组成权重值',value:'5',color:'warning'},
      {label:'桥梁技术状况分类界限表',value:'6',color:'warning'},
      {label:'土建结构指标类型',value:'7',color:'warning'},
      {label:'机电设施指标类型',value:'8',color:'warning'},
      {label:'其它工程设施指标类型',value:'9',color:'warning'},
      {label:'隧道总体技术状况评定',value:'10',color:'warning'},
      {label:'土建结构分项权重',value:'11',color:'warning'},
      {label:'机电设施分项权重',value:'12',color:'warning'},
      {label:'其它工程设施分项权重',value:'13',color:'warning'}
  ],
  targetTypeD:[
    {label:'路基损坏扣分标准',value:'1',color:'warning'},
    {label:'PQI分项指标权重',value:'2',color:'warning'},
    {label:'沥青路面损坏类型和权重',value:'3',color:'warning'},
    {label:'指标阈值',value:'4',color:'warning'},
    {label:'桥隧构造物扣分标准',value:'5',color:'warning'},
    {label:'沿线设施扣分标准',value:'6',color:'warning'},
    {label:'各项技术状况评定标准',value:'7',color:'warning'},
    {label:'MQI分项指标权重',value:'8',color:'warning'},
    {label:'水泥路面损坏类型和权重',value:'9',color:'warning'},
    {label:'砂石路面损坏类型和权重',value:'10',color:'warning'},
  ],
  iconType:[
      {value:"",icon:"frown-o",style:"color:red;font-size:20px;"},
      {value:null,icon:"frown-o",style:"color:red;font-size:20px;"},
      {value:"0",icon:"frown-o",style:"color:red;font-size:20px;"},
      {value:"1",icon:"smile-o",style:"color:#8ac007;font-size:20px;"},
      {value:"2",icon:"smile-o",style:"color:#8ac007;font-size:20px;"}
  ],
  iconapplyType:[
      {value:"",icon:"frown-o",style:"color:red;font-size:20px;",title:"未验收"},
      {value:null,icon:"frown-o",style:"color:red;font-size:20px;",title:"未验收"},
      {value:"0",icon:"frown-o",style:"color:red;font-size:20px;",title:"未验收"},
      {value:"1",icon:"meh-o",style:"color:rgb(0, 174, 239);font-size:20px;",title:"验收中"},
      {value:"2",icon:"smile-o",style:"color:#8ac007;font-size:20px;",title:"已验收"}
  ],
  datafromType:[
        {label:'离线上传',value:'offline'},
        {label:'实时上传',value:'Inspect'},
  ],
  warningflag:[
        {label:'预警',value:'1'},
        {label:'不预警',value:'0'},
  ],
  inspectdirection:[
        {label:'上行',value:'0'},
        {label:'下行',value:'1'},
  ],
  iscalibrated:[
        {label:'未校准',value:'0'},
        {label:'已校准',value:'1'},
  ],
    // 路产类型
    equipmenttype: [
        {label:'沥青路面',value:'100000'},
        {label:'禁令标志',value:'150000'},
        {label:'指示标志',value:'150001'},
        {label:'警告标志',value:'150002'},
        {label:'指路标志',value:'150003'},
        {label:'辅助标志',value:'150004'},
        {label:'护栏',value:'150100'},
        {label:'中分带绿植',value:'150200'},
        {label:'防眩板',value:'150300'},
        {label:'声屏障',value:'150400'},
        {label:'交通标线',value:'150500'},
        {label:'黃玥厥缘石',value:'150700'},
        {label:'球机',value:'151000'},
        {label:'枪机',value:'151001'},
        {label:'信号灯',value:'152000'},
        {label:'抛洒物',value:'170500'},
    ],
    // 病害类型
    defectType: [
        {label:'横向裂缝',value:'0'},
        {label:'纵向裂缝',value:'1'},
        {label:'网状裂缝',value:'2'},
        {label:'坑槽',value:'1000'},
        {label:'其他',value:'1001'},
        {label:'带状修补',value:'2000'},
        {label:'块状修补',value:'2001'},
        {label:'锚固区缺损',value:'2100'},
        {label:'标志缺损',value:'70000'},
        {label:'护栏缺损',value:'70010'},
        {label:'中分带绿植缺死',value:'70020'},
        {label:'防眩板缺损',value:'70030'},
        {label:'声屏障缺损',value:'70040'},
        {label:'标线模糊',value:'70050'},
        {label:'路缘石缺损',value:'70060'},
    ],
    // 病害状态
    diseaseStatus: [
        {label:'是',value:'1'},
        {label:'否',value:'2'},

    ]
}

export default util